const cnPhone = /^1[3|4|5|6|7|8|9]\d{9}$/

// 手机号
export default function (value, countryCode) {
  value = value.trim()

  if (!countryCode) {
    return {
      validate: false,
      message: '未指定区号'
    }
  }

  if (/^\d+$/.test(countryCode)) {
    if (countryCode === '86' && !cnPhone.test(value)) {
      return {
        validate: false,
        message: '手机号码输入有误'
      }
    }

    return {
      validate: true
    }
  } else {
    return {
      validate: false,
      message: '手机号码格式有误'
    }
  }
}
